( function () {
	'use strict';

	/* @ngInject */
	function ModalConfirm ( $modalInstance, $location ) {
		var self = this;

		function confirmAccept () {
			$modalInstance.close( true );
		}

		function confirmDeny () {
			$modalInstance.close( false );
			$location.path( '/templates' );
		}

		self.confirmAccept = confirmAccept;
		self.confirmDeny   = confirmDeny;
	}

	angular
		.module( 'app.components' )
		.controller( 'ModalConfirm', ModalConfirm );

	ModalConfirm.$inject = [ '$modalInstance', '$location' ];
} )( );
